import { assetsApi } from "@iventis/api/src/api";
import { Asset } from "@iventis/domain-model/model/asset";
import { AssetCategory } from "@iventis/domain-model/model/assetCategory";
import { AssetType } from "@iventis/domain-model/model/assetType";
import { Hierarchy } from "@iventis/domain-model/model/hierarchy";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { RootState } from "../state/root.store";

const MAP_BACKGROUNDS_KEY = "map-backgrounds";
const MAP_BACKGROUND_TAGS_KEY = "map-background-tags";

export function useMapBackgrounds() {
    const mapBackgrounds = useSelector((reducer: RootState) => reducer.mapReducer.mapBackgrounds);
    return { mapBackgrounds };
}

/** Fetches the category tags for MapBackground assets from the API, matching how icons/models fetch their categories. */
export function useMapBackgroundTags() {
    const { data, isLoading } = useQuery({
        queryKey: [MAP_BACKGROUND_TAGS_KEY],
        queryFn: async () => {
            const res = await assetsApi.get<Hierarchy<AssetCategory>[]>(`/tags?assetType=${AssetType.MapBackground}`);
            return res.data;
        },
        refetchOnMount: false,
    });
    return { mapBackgroundTags: data, isMapBackgroundTagsLoading: isLoading };
}

export function useMapBackground(id: string) {
    const { data, isLoading } = useQuery({
        queryKey: [MAP_BACKGROUNDS_KEY, id],
        queryFn: () => assetsApi.get<Asset>(`/assets/${id}`).then((res) => res.data),
        enabled: id !== "",
        refetchOnMount: false,
        placeholderData: (previousData) => previousData,
    });
    return { mapBackground: data, isMapBackgroundLoading: isLoading };
}
